<template>
    <div :class="['toast_container', positions]">
        <slot></slot>
    </div>
</template>

<script>
import { computed } from 'vue'
export default {
    name: 'AppToast',
    props: {
        position: {
            type: String,
            default: 'bottom-left',
        },
    },
    setup(props) {
        const positions = computed(() => {
            if (props.position === 'bottom-right') {
                return 'bottom-right'
            } else if (props.position === 'top-right') {
                return 'top-right'
            } else if (props.position === 'top-left') {
                return 'top-left'
            }
            return 'bottom-left'
        })
        return {
            positions,
        }
    },
}
</script>

<style scoped>
.toast_container {
    @apply fixed z-50 w-full max-w-[34.375rem] m-[1.3125rem] ;
}
.bottom-left {
    @apply ltr:left-0 rtl:right-0 bottom-0;
}
.bottom-right {
    @apply ltr:right-0 rtl:left-0 bottom-0;
}
.top-left {
    @apply ltr:left-0 rtl:right-0 top-0;
}
.top-right {
    @apply ltr:right-0 rtl:left-0 top-0;
}
</style>
